import { getLoginUrl, getSignupUrl } from '../../config/surface'

/** Hero — VistoeraTASK-00262. Copy describes only what the product
 * already does today (Canvas 内容生产：创意/剧本/分镜/图片/视频/音频生成节点
 * 自由编排 + 素材资产管理) — no unreleased capability. Previous revision
 * (spec §10) described the earlier single-function 商品图片处理 tool that
 * predates the Canvas/SaaS pivot; retired 2026-09-28. */
export default function Hero() {
  return (
    <section className="mkt-hero" id="top">
      <div className="mkt-container">
        <span className="mkt-eyebrow">免费注册体验</span>
        <h1>用一个 Canvas，编排你的内容生产工作流</h1>
        <p className="mkt-hero-sub">
          在同一个画布上连接创意、剧本、分镜与图片/视频/音频生成节点，构建可复用的内容生产流程，随时调整并管理你的成品资产。
        </p>
        <div className="mkt-hero-cta">
          <a className="mkt-btn mkt-btn-primary mkt-btn-lg" href={getSignupUrl()}>
            免费开始使用
          </a>
          <a className="mkt-btn mkt-btn-ghost mkt-btn-lg" href={getLoginUrl()}>
            登录
          </a>
        </div>
        <p className="mkt-hero-note">无需信用卡</p>
      </div>
    </section>
  )
}
